/* eslint-disable import/prefer-default-export */
import { useLocalizedData } from "contexts/LocalizationContext/hooks";

import config from "config/config";
import { NumberOneIcon, NumberTwoIcon, NumberThreeIcon } from "styles/icons";

export const AHPLUS_PRICE = 19.99;
export const AHPLUS_HIGHER_PRICE = 29.99;
export const AHPLUS_COMPLETE_PRICE = 49.99;
export const AHPLUS_PER_MONTH_PRICE = 1.66;
export const AHPLUS_COMPLETE_PER_MONTH_PRICE = 4.16;

export const PRICING_PLANS_ANCHOR = "pricing-plans";
export const FEATURES_ANCHOR = "features";
export const REVIEWS_ANCHOR = "reviews";
export const FAQ_ANCHOR = "faq";

export const LOUNGE_ACCESS_REFUND = 35;

export const ESSENTIAL_PLAN_PATH = "/plus-membership/checkout?channel=lp_essential";
export const COMPLETE_PLAN_PATH = "/plus-membership/checkout?channel=lp_complete";

export const OG_IMAGE_URL = `${config.staticUrl}/i/airhelp-plus/airhelp-plus-share.png`;

export const BOTTOM_BAR_CHECKMARKS = ["all_airlines", "all_countries", "all_flights"];

export const GetMoneySectionListItems = () => {
  const { getCompensationValue } = useLocalizedData();

  return [
    {
      preview: "money_list_flight_disruptions",
      boxHeading: "money_box_flight_disruptions",
      boxContent: "money_box_flight_disruptions_no_matter",
      translationVariables: {
        "%compensation%": getCompensationValue("compensation", "EUR"),
      },
    },
    {
      preview: "money_list_luggage_problems",
      boxHeading: "money_box_luggage_problems",
      boxContent: "money_box_luggage_problems_luggage_late",
      translationVariables: {
        "%compensation%": getCompensationValue("luggage", "EUR"),
      },
    },
    {
      preview: "money_list_expenses",
      boxHeading: "money_box_expenses",
      boxContent: "money_box_expenses_unplanned_costs",
      translationVariables: {
        "%compensation%": getCompensationValue("extraExpenses", "EUR"),
      },
    },
  ];
};

export const HOW_IT_WORKS_ITEMS = [
  { icon: NumberOneIcon, header: "how_join_today", description: "how_buy_today_and_relax" },
  { icon: NumberTwoIcon, header: "how_activate", description: "how_add_your_upcoming_flight" },
  { icon: NumberThreeIcon, header: "how_enjoy_benefits", description: "how_access_dedicated" },
];

export const MENU_LINKS = [
  {
    href: `#${FEATURES_ANCHOR}`,
    title: "menu_features",
  },
  {
    href: `#${PRICING_PLANS_ANCHOR}`,
    title: "menu_pricing",
    hasMobileMarginTop: true,
  },
  {
    href: `#${REVIEWS_ANCHOR}`,
    title: "menu_reviews",
    hasMobileMarginTop: true,
  },
  {
    href: `#${FAQ_ANCHOR}`,
    title: "menu_faq",
    hasMobileMarginTop: true,
    removeDesktopMarginRight: false,
  },
  {
    href: `${config.webappUrl}/plus`,
    title: "button_login",
    hasMobileMarginTop: true,
    removeDesktopMarginRight: false,
  },
];

export const STATISTICS_ITEMS = [
  {
    header: "numbers_flights",
    subHeader: "numbers_flights_a_year",
    description: "numbers_over_million_flights",
  },
  {
    header: "numbers_people",
    subHeader: "numbers_people_a_day",
    description: "numbers_thousands_of_people",
  },
  {
    header: "numbers_passengers",
    subHeader: "numbers_of_air_passengers",
    description: "numbers_most_air_passengers",
  },
];

export const usePricingPlanDetailsConfig = () => {
  const { getCompensationValue, getLocalizedCurrency } = useLocalizedData();

  return {
    essential: {
      planType: "essential",
      promoText: "plan_now_price",
      translationVariables: {
        "%price%": getLocalizedCurrency(AHPLUS_PRICE, "EUR", 2),
        "%higher-price%": getLocalizedCurrency(AHPLUS_HIGHER_PRICE, "EUR", 2),
      },
      price: AHPLUS_PRICE,
      pricePerMonth: getLocalizedCurrency(AHPLUS_PER_MONTH_PRICE, "EUR", 2),
      nameText: "plan_essential",
      buttonText: "button_choose_essential",
      buttonType: "primary",
      buttonPath: ESSENTIAL_PLAN_PATH,
      items: [
        {
          text: "plan_compensation_claims",
          translationVariables: {
            "%compensation%": getCompensationValue("compensation", "EUR"),
          },
        },
        {
          text: "plan_expenses_claims",
          translationVariables: {
            "%extra-expenses%": getCompensationValue("extraExpenses", "EUR"),
          },
        },
        {
          text: "plan_luggage_claims",
          translationVariables: {
            "%luggage-compensation%": getCompensationValue("luggage", "EUR"),
          },
        },
        {
          text: "plan_assistance_with_refunds",
        },
        {
          text: "plan_live_chat",
          popover: "plan_hover_live_chat",
        },
      ],
    },
    complete: {
      planType: "complete",
      price: AHPLUS_COMPLETE_PRICE,
      pricePerMonth: getLocalizedCurrency(AHPLUS_COMPLETE_PER_MONTH_PRICE, "EUR", 2),
      nameText: "plan_complete",
      buttonText: "button_choose_complete",
      buttonType: "primary",
      buttonPath: COMPLETE_PLAN_PATH,
      items: [
        {
          text: "plan_all_essential_benefits",
          highlighted: true,
        },
        {
          text: "plan_airport_lounge_access",
          popover: "plan_airport_lounge_access_hover",
          translationVariables: {
            "%lounge-refund%": getLocalizedCurrency(LOUNGE_ACCESS_REFUND, "EUR"),
          },
        },
        {
          text: "plan_range_of_lounge_amenities_included",
          popover: "plan_range_of_lounge_amenities_included_hover",
        },
      ],
    },
  };
};
